<template>
  <vs-row
    :class="{ selected: file.idAprobacion === selectedFile }"
    class="p-3 mt-2 bg-white shadow-sm bg-white"
  >
    <vs-col vs-lg="11">
      <vs-row>
        <vs-col class="text-center text-primary" vs-lg="1">
          <div class="text-center m-auto" v-if="showCheck">
            <b-form-checkbox
              v-if="process && !isBlocked"
              v-model="file.selected"
              @change="selectFileToProcess"
            />
            <vs-avatar
              icon="alarm_on"
              color="#adadad"
              v-if="isBlocked"
            />
          </div>
          <div class="d-flex justify-content-center">
            <span v-if="file.app === 'FEB'" v-tooltip="'Flujo de Febos'">
              <vs-chip
                color="warning"
                :class="{ 'text-success': wasCopied }"
                class="cursor-pointer mr-2"
                data-cy="file-number"
                @click.native="copyToClipboard(file.id, file.numero)"
              >
                {{file.numero}}
              </vs-chip>
            </span>
            <span
              v-if="file.app === 'ED' && file.tipoObjetoId === 'ARCHIVO-RP'"
              v-tooltip="'Repositorio'"
            >
              <vs-chip
                color="primary"
                :class="{ 'text-success': wasCopied }"
                class="cursor-pointer mr-2"
                data-cy="file-number"
                @click.native="copyToClipboard(file.id, file.numero)"
              >
                <vs-avatar color="primary" text="R"/>
                {{file.numero}}
              </vs-chip>
            </span>
            <span
              v-if="file.app === 'ED' && file.tipoObjetoId === 'EXP'"
              v-tooltip="'Expediente'"
            >
              <vs-chip
                color="primary"
                :class="{ 'text-success': wasCopied }"
                class="cursor-pointer mr-2"
                data-cy="file-number"
                @click.native="copyToClipboard(file.id, file.numero)"
              >
                <vs-avatar color="primary"  text="E"/>
                {{file.numero}}
              </vs-chip>
            </span>
            <span
              v-if="file.app === 'ED' && file.tipoObjetoId === 'ARCHIVO'"
              v-tooltip="'Archivo'"
            >
              <vs-chip
                color="primary"
                :class="{ 'text-success': wasCopied }"
                class="cursor-pointer mr-2"
                data-cy="file-number"
                @click.native="copyToClipboard(file.id, file.numero)"
              >
                <vs-avatar color="primary"  text="A"/>
                {{file.numero}}
              </vs-chip>
            </span>
          </div>
        </vs-col>
        <vs-col vs-lg="3">
          {{ file.nombre }}
          <div v-tooltip="`${file.descripcion}`">
            <small class="text-primary">
              {{file.descripcion | truncate(40)}}
            </small>
          </div>
        </vs-col>
        <vs-col vs-lg="2">
          {{ file.autor }}
        </vs-col>
        <vs-col vs-lg="2">
          <vs-chip
            data-cy="flow-started"
            v-if="file.aprobacionesEjecucionEstadoId.toString()
             === FileStates.INITIATED"
            title="Iniciado"
          >
            <vs-avatar icon="query_builder" color="#43C3B9" />
            Iniciado
          </vs-chip>
          <vs-chip
            title="Pendiente"
            v-if="file.aprobacionesEjecucionEstadoId.toString()
             === FileStates.PREPARED"
          >
            <vs-avatar icon="language" color="#adadad" />
            Preparado
          </vs-chip>
          <vs-chip
            data-cy="approved-flow"
            title="Aprobado"
            v-if="file.aprobacionesEjecucionEstadoId.toString()
             === FileStates.APPROVED"
          >
            <vs-avatar icon="thumb_up" color="#28c76f" />
            Aprobado
          </vs-chip>
          <vs-chip
            data-cy="rejected-flow"
            title="Rechazado"
            v-if="file.aprobacionesEjecucionEstadoId.toString()
             === FileStates.REJECTED"
          >
            <vs-avatar icon="thumb_down" color="#ea5455" />
            Rechazado
          </vs-chip>
          <vs-chip
            data-cy="null-flow"
            title="Retornado"
            v-if="file.aprobacionesEjecucionEstadoId.toString()
             === FileStates.CANCELED"
          >
            <vs-avatar icon="block" color="#bf0303" />
            Anulado
          </vs-chip>
          <vs-chip
            data-cy="dismissed-flow"
            title="Desestimado"
            v-if="file.aprobacionesEjecucionEstadoId.toString()
             === FileStates.DISMISSED"
          >
            <vs-avatar icon="save_alt" color="#848484" />
            Desestimado
          </vs-chip>
        </vs-col>
        <vs-col vs-lg="2">
          <vs-chip
            v-if="file.tipoGrupo === 'Oficina'"
            v-tooltip="'Oficina'"
            color="dark"
            transparent
            data-cy="office"
            class="mr-4"
          >
            {{file.unidadNombre}}
          </vs-chip>
          <vs-chip
            v-if="file.tipoGrupo === 'Unidad'"
            v-tooltip="'Unidad'"
            color="success"
            transparent
            data-cy="unit"
            class="mr-4"
          >
            {{file.unidadNombre}}
          </vs-chip>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col vs-offset="1" vs-lg="10" vs-type="flex" class="pt-2 border-top">
          <vs-chip class="mr-4" v-tooltip="'Fecha inicio del proceso'">
            <vs-avatar icon="date_range" />
            {{file.fechaInicioProceso | dateFormat }}
          </vs-chip>
          <vs-chip class="mr-4" v-tooltip="'Fecha actualización del proceso'">
            <vs-avatar icon="date_range" />
            {{file.fechaActualizacion | dateFormat }}
          </vs-chip>
          <vs-chip
            class="mr-4"
            v-tooltip="'Proceso de pasos'"
            color="primary" transparent
          >
            <vs-avatar icon="group" />
            paso {{file.numeroPaso}} de {{file.totalPasos}}
          </vs-chip>
          <b-avatar
            v-if="file.retenido === 'Y'"
            v-tooltip="'Esta retenido'"
            pill
            class="mr-4"
            size="28"
            variant="danger"
            data-cy="detained"
          >
            <feather-icon
              size="18"
              icon="LockIcon"
            />
          </b-avatar>
          <vs-chip
            v-tooltip="'Nombre de documento en flujo'"
            color="warning" transparent
            class="mr-4"
          >
            <vs-avatar icon="description" />
            {{file.objetoNombre | truncate(20)}}
          </vs-chip>
          <steps-info-pre-office
            v-tooltip="'Estado del paso'"
            v-if="view === 'pre-oficina'"
            :step="file.aprobacionesTipoPasoId.toString()"
          />
          <vs-chip
            v-if="file.privado === 'Y'"
            v-tooltip="'Privado'"
            color="primary"
            transparent
            class="mr-4"
            data-cy="private"
          >
            <vs-avatar icon="lock" />
            privado
          </vs-chip>
          <vs-chip
            v-if="file.folio"
            v-tooltip="'Folio'"
            color="warning"
            transparent
            class="mr-4"
            data-cy="document-folio"
          >
            <vs-avatar icon="description" />
            {{file.folio}}
          </vs-chip>
          <vs-chip
            v-if="file.foliado"
            v-tooltip="'Fecha de documento'"
            color="warning"
            transparent
            class="mr-4"
          >
            <vs-avatar icon="date_range" />
            {{file.foliado | dateFormat}}
          </vs-chip>
          <vs-chip
            v-if="file.tipoObjetoCategoria"
            v-tooltip="'Tipo de documento'"
            color="warning"
            transparent
            class="mr-4"
            data-cy="document-type"
          >
            <vs-avatar icon="description" />
            {{file.tipoObjetoCategoria | truncate(20)}}
          </vs-chip>
          <vs-chip
            v-if="file.oficinaNombre"
            v-tooltip="'Oficina que numeró o tramitó'"
            color="warning"
            transparent
            class="mr-4"
          >
            <vs-avatar icon="apartment" />
            {{file.oficinaNombre}}
          </vs-chip>
          <vs-chip
            v-if="file.app === 'FEB'"
            v-tooltip="'Tipo de documento en flujo'"
            color="warning"
            transparent
            class="mr-4"
          >
            <vs-avatar icon="description" />
            {{findTypeDocument(file.tipoReferencia)}}
          </vs-chip>
          <vs-chip
            v-if="file.numeroReferencia"
            v-tooltip="'Número de documento'"
          >
            <vs-avatar icon="tag" />
            {{file.numeroReferencia}}
          </vs-chip>
          <b-avatar
            v-tooltip="'Flujo atendido'"
            v-if="file.desatendida !== 1"
            color="#28c76f"
            pill
            class="mr-4"
            size="28"
            data-cy="attended-flow"
          >
            <feather-icon
              size="18"
              icon="BellIcon"
            />
          </b-avatar>
          <b-avatar
            v-tooltip="'Flujo desatendido'"
            v-if="file.desatendida === 1"
            color="orange"
            pill
            class="mr-4"
            data-cy="unattended-flow"
            :icon="null"
            variant="warning"
            size="28"
          >
            <feather-icon
              size="18"
              icon="BellOffIcon"
            />
          </b-avatar>
          <vs-chip
            v-if="file.plantilla"
            v-tooltip="'Plantilla'"
          >
            <vs-avatar icon="tag" />
            {{file.plantilla}}
          </vs-chip>
        </vs-col>
      </vs-row>
    </vs-col>
    <vs-col vs-lg="1" vs-type="flex" vs-justify="center" vs-align="center">
      <FileOptions
        :file="file"
        :select-file="selectFile"
      />
    </vs-col>
  </vs-row>
</template>

<script>

import { mapGetters } from 'vuex';

import FileOptions from '@/febos/chile/approvals/components/trays/FileOptions';
import StepsInfoPreOffice from '@/febos/chile/approvals/components/trays/StepsInfoPreOffice';
import FileStates from '@/febos/chile/approvals/mixins/FileStates';
import CopyToClipboard from '@/febos/chile/approvals/mixins/CopyToClipboard';

export default {
  components: { FileOptions, StepsInfoPreOffice },
  mixins: [FileStates, CopyToClipboard],
  props: [
    'file',
    'selectFile',
    'process',
    'blockedProcess',
    'showCheck'
  ],
  data() {
    return {
      view: this.$route.params.view,
      FileStates,
      types: {
        0: 'Otros',
        30: 'Factura',
        32: 'Factura Exenta',
        33: 'Factura Afecta Electrónica',
        34: 'Factura Exenta Electrónica',
        35: 'Boleta',
        38: 'Boleta Exenta',
        39: 'Boleta Afecta Electrónica',
        41: 'Boleta Exenta Electrónica',
        45: 'Factura de Compra',
        46: 'Factura Electrónica de Compra',
        43: 'Liquidación de Factura',
        50: 'Guía de Despacho',
        60: 'Nota de Crédito',
        55: 'Nota de Débito',
        52: 'Guía de Despacho Electrónica',
        56: 'Nota de Débito Electrónica',
        61: 'Nota de Crédito Electrónica',
        99: 'Anticipos y otras Transacciones',
        110: 'Factura de Exportación Electrónica',
        111: 'Nota de Débito de Exportación Electrónica',
        112: 'Nota de Crédito de Exportación Electrónica',
        801: 'Orden de Compra',
        802: 'Nota de Pedido',
        803: 'Contrato',
        804: 'Resolución',
        805: 'Proceso Chile Compra',
        806: 'Ficha Chile Compra',
        807: 'DUS',
        808: 'B/L Conocimiento de Embarque',
        809: 'AWB',
        810: 'MIC/DATA',
        811: 'Carta de Porte',
        812: 'Res. SNA Servicio Exportación',
        813: 'Pasaporte',
        814: 'Cert. Depósito BP',
        815: 'Vale Prenda BP',
        RD1: 'Rendicion de Financiamiento',
        RD2: 'Rendicion de Gastos',
        HES: 'HES - Hoja Entrada Servicio',
        HEM: 'HEM - Hoja Entrada Mercaderia',
        SCO: 'SCO - Solicitud de Compra',
        MP: 'Orden de Compra MP',
        NV: 'Nota de Venta',
        FIN: 'Factura Interna',
        LIC: 'Licitación',
        BGT: 'Boleta',
        BG: 'Boleta de Garantía',
        BTG: 'Boleta de Garantía',
        PZ: 'Póliza',
        SWF: 'Swift',
        PGR: 'Pagare',
        VLV: 'Vale Vista',
        CHI: 'Cheque Internacional',
        CHN: 'Cheque Nacional',
        EPG: 'Estado de Pago',
        PRY: 'Proyecto',
        CFZ: 'Certificado de Fianza',
        ARCHIVO: 'Archivo',
        NPP: 'Nómina Pronto Pago',
        APR: 'Acta de Aprobación',
        ACRE: 'Expediente',
        MEMO: 'Memorándum',
        DTE: 'Documento Tributario',
        DNT: 'Documento no Tributario',
        EXP: 'Expediente',
        SSD: 'Proceso SSD',
        DDD: 'DocDigital',
        ALI: 'Antecedentes Licitación',
        BIM: 'Banco de Imágenes',
        BOL: 'Boletas',
        CERT: 'Certificado'
      }
    };
  },
  computed: {
    ...mapGetters('Approvals', [
      'selectedFile',
      'documentTypeReferences'
    ]),
    isBlocked() {
      return this.blockedProcess.some((flow) => flow.idAprobacion === this.file.idAprobacion);
    }
  },
  methods: {
    findTypeDocument(typeDocument) {
      const typesArray = Object.keys(this.types)
        .map((type) => ({ valor: type, descripcion: this.types[type] }));
      const documents = typesArray.concat(this.documentTypeReferences);
      const typeDoc = documents.find((doc) => doc.valor === typeDocument);
      return typeDoc ? typeDoc.descripcion : '-';
    },
    selectFileToProcess() {
      if (this.file.selected) {
        this.$emit('select-flow', this.file);
        return;
      }
      this.$emit('unselect-flow', this.file);
    }
  }
};

</script>
<style>
.selected {
  background: rgba(var(--vs-primary), 0.1) !important;
}
</style>
